import { render, staticRenderFns } from "./startEnd.vue?vue&type=template&id=3f2ff440"
import script from "./startEnd.vue?vue&type=script&lang=js"
export * from "./startEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports